import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'
import AnimationContainer from 'components/animation-container'


class Hosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {        

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 80px 0 50px 0;
            .heading {
                width: 100%;            
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 10px;
        `
        const ServiceRow1 = styled(Row)`
            margin-top: 50px;
        `

        const TecText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #4c4c4c;            
        `

        const Text = styled.p`
        font-size: 17px;
        font-family: "Open Sans", sans-serif;
        color: #777;        
        `
        const Color3 = styled.span`          
          color: #40a832;              
        `

        const Heading2 = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 70px;
            line-height: 80px;            
            font-weight: 700;
            color: #000;
            text-align: center;
            @media (max-width: 767px) {
                font-size: 50px;
                line-height: 50px;
            }
        `


        return (
            <Section id="faq">
                <Container>                    

                    <Heading2><Color3>Preguntas Frecuentes sobre </Color3>Hosting y Tecnología en Colombia</Heading2>
                    <ServiceRow>
                        <Col md={12}>
                            <TecText>
                                Encuentra respuestas sobre hosting con SSL gratis, diseño web, SEO y más para tu empresa en Pereira, Bogotá, Medellín y Cali. ¡Resuelve tus dudas ahora!
                            </TecText>
                        </Col>
                    </ServiceRow>
                    <ServiceRow1>
                        <Col md={12}>
                            <AnimationContainer animation="fadeInDown" delay={500}>
                                <Accordion defaultActiveKey="0">
                                    {/* Item 0 */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            ¿Qué incluye el hosting con SSL gratis en Colombia?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Nuestros planes de hosting en Colombia incluyen SSL gratis, cPanel, almacenamiento SSD, dominio gratis (en planes seleccionados),
                                                y soporte 24/7. Perfectos para pymes en Pereira, Bogotá, Cali que buscan seguridad y rendimiento. ¡Cotiza hoy!
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 1 */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            ¿Cómo elegir el mejor hosting en Colombia?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Busca planes con SSL gratis, cPanel, y soporte local. Nuestros servicios en Pereira, Bogotá, Medellín, Cali ofrecen alta velocidad, seguridad
                                                y precios por menos de $100.000/año. ¡Contáctanos!
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 2 */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            ¿Qué es un certificado SSL gratis y por qué lo necesito?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Un SSL gratis protege tu web con cifrado HTTPS, mejora el SEO, y genera confianza. Incluido en nuestros planes de hosting y RapidSSL Trial (90 días gratis).
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 3 */}
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            ¿Qué son los planes multidominios?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Los planes multidominio o con dominios adicionales, son los planes hosting que le permiten tener varios sitios web o varios dominios
                                                registrados en la misma cuenta, aparte del dominio principal.
                                                Por ejemplo:
                                                mi-dominio-principal.com
                                                mi-sitio-secundario.com
                                                mi-dominio-adicional.com
                                                Estos 3 dominios pueden alojarse en la misma cuenta o plan hosting, pero debe tener en cuenta que para ello deben estar registrados los 3 dominios.
                                                El primero de ellos seria el dominio principal de la cuenta y los otros 2, serian los dominios adicionales o apuntados en la misma cuenta
                                                o plan hosting, si este se lo permite.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 4 */}
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>
                                            ¿Qué es cPanel?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                cPanel es un panel de control para administrar servidores de alojamiento web que proveen herramientas de automatización
                                                y una interfaz gráfica basada en páginas web.
                                                A través de este panel de control es posible instalar aplicaciones, monitorear el rendimiento de las páginas y, también,
                                                realizar configuraciones y ediciones de todos los niveles en un entorno.
                                                Actualmente, cPanel es el estándar de la industria y la mayoría de los desarrolladores web lo conocen bien.
                                                Intuitivo y fácil de usar, cPanel te permite administrar una cuenta de hosting web con la máxima eficiencia.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 5 */}
                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>
                                            ¿Cuánto cuesta el hosting en Colombia?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Los precios para un hosting en Colombia son relativamente bajos y lo mejor de todo, en pesos y en español.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 6 */}
                                    <Accordion.Item eventKey="6">
                                        <Accordion.Header>
                                            ¿Cuál es el mejor hosting en Colombia?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                En primer lugar, considera el tipo de sitio web que estás construyendo y el tráfico que esperas recibir. Esto te ayudará a
                                                determinar si necesitas un plan de hosting compartido, VPS o dedicado. Además, presta atención al rendimiento y la velocidad
                                                del servidor. Asegúrate de elegir un proveedor de hosting con servidores confiables y rápidos para garantizar una experiencia
                                                óptima para tus usuarios. El soporte técnico es otro aspecto crucial a considerar. Busca un proveedor que ofrezca un soporte
                                                técnico eficiente y receptivo, ya sea a través de tickets, correo electrónico o teléfono. Esto te brindará tranquilidad
                                                sabiendo que puedes obtener ayuda rápidamente si surge algún problema. No olvides tener en cuenta la seguridad. Es
                                                fundamental elegir un proveedor de hosting que ofrezca medidas de seguridad sólidas, como firewalls, certificados SSL y
                                                copias de seguridad automáticas, para proteger tu sitio web y los datos de tus usuarios. Finalmente, compara los precios
                                                y las características de diferentes proveedores de hosting y elige el que mejor se adapte a tus necesidades y presupuesto.
                                                Como empresa de hosting en Colombia, estamos aquí para ayudarte en este proceso y ofrecerte soluciones que impulsen el
                                                éxito de tu sitio web. Si tienes alguna pregunta o necesitas asistencia, no dudes en contactarnos. Estamos aquí para
                                                ayudarte a encontrar la mejor opción de hosting para tu proyecto.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 7 */}
                                    <Accordion.Item eventKey="7">
                                        <Accordion.Header>
                                            ¿Ofrecen diseño web en Pereira?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Sí, creamos páginas web optimizadas y tiendas virtuales en Pereira. Desde diseños personalizados hasta e-commerce, mejoramos
                                                tu presencia online. ¡Cotiza ahora!
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 8 */}
                                    <Accordion.Item eventKey="8">
                                        <Accordion.Header>
                                            ¿Cómo mejorar mi posicionamiento SEO en Pereira?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Nuestro servicio de SEO en Pereira optimiza tu web para Google, captando tráfico local. Incluye auditorías, palabras clave
                                                y estrategias personalizadas. ¡Contáctanos!
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 9 */}
                                    <Accordion.Item eventKey="9">
                                        <Accordion.Header>
                                            ¿Qué es la Seguridad de la Información para mi empresa?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                La Seguridad de la Información protege tus datos con soluciones de <b>ciberseguridad y seguridad informática</b>. Ofrecemos asesorías,
                                                auditorías y sistemas SGSI en Pereira, Bogotá, Medellín, Eje cafetero, garantizando la continuidad de tu negocio. ¡Consulta nuestra ciberseguridad
                                                en Colombia gratis!
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </AnimationContainer>
                        </Col>
                    </ServiceRow1>
                </Container>
            </Section>
        )
    }

}

export default Hosting